import { SHFilterOption } from "@components/design-systems";
import {
  MSFilterFavouriteSwitchValues,
  MSFilterSwitchValues,
} from "@models/model-screener/enums/filterValues";
import { template } from "lodash";

export const MSFilterSwitchOptions: SHFilterOption[] = [
  { value: MSFilterSwitchValues.Each, label: "Each" },
  { value: MSFilterSwitchValues.Any, label: "Any" },
  { value: MSFilterSwitchValues.Not, label: "Not" },
];

export const MSFilterFavouriteOptions: SHFilterOption[] = [
  { value: MSFilterFavouriteSwitchValues.All, label: "All" },
  { value: MSFilterFavouriteSwitchValues.Favourites, label: "Favourites" },
];

export class MSFilterDefaultValueConstants {
  static readonly StandardDelayTimeMs = 300;
  static readonly SliderMinValue = 0;
  static readonly SliderMaxValue = 100;
  static readonly SliderLimitRangeMin = -100;
  static readonly SliderLimitRangeMax = 100;
  static readonly SliderStep = 1;
  static readonly SwitchValue = MSFilterSwitchValues.Each;
  static readonly FavouriteSwitchValue = MSFilterFavouriteSwitchValues.All;
  static readonly MSDefaultFilterId = "DefaultFilter";
  static readonly MSDefaultFilterName = "SuitabilityHub Default";
}

export const MSFilterIncludeOptionTooltipTemplate = template(
  "If you check this box, the filter will assume a TRUE value even if a model has <%= responseType %> response",
);

export class MSFilterSaveModalHelpTextConstants {
  static readonly HelpText =
    "This filter is available only to you. Give it a name to help you find it in the future. You can overwrite an existing filter by giving it the same name.";
}
